export default "__VITE_ASSET__2feb5e97__"